import React from 'react'
import { useOrderTicket, } from '../use-order-ticket'

export default () => {
    const { snapshotView:view, setSnapshotView:setView, positionsCount, openOrdersCount } = useOrderTicket()

    return <React.Fragment>
    <div data-name="order-ticket-snapshot-nav-tabs" className="nav-tabs nav-tabs-border">
    <ul role="tablist">

        <li role="presentation"
            className={ !view || view==='snapshot' ? 'active' : '' }>
            <button
                data-name="order-ticket-snapshot-nav-tab"
                data-toggle="tab"
                role="tab"
                aria-selected={ !view || view==='snapshot' }
                onClick={() => setView('snapshot')}
            >Snapshot</button>
        </li>

        <li role="presentation"
            className={ view==='positions' ? 'active' : '' }>
            <button
                data-name="order-ticket-snapshot-positions-nav-tab"
                data-toggle="tab"
                role="tab"
                aria-selected={ view==='positions' }
                onClick={() => setView('positions')}
            >Positions {`(${positionsCount})`} </button>
        </li>

        <li role="presentation"
            className={ view==='open-orders' ? 'active' : '' } >
            <button
                data-name="order-ticket-snapshot-open-orders-nav-tab"
                data-toggle="tab"
                role="tab"
                aria-selected={ view==='open-orders' }
                onClick={() => setView('open-orders')}
            >Open Orders {`(${openOrdersCount})`}</button>
        </li>

    </ul>
    </div>
    </React.Fragment>
}